function formatPaidAtLabel(value) {
    if (!value) {
        return '—';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return new Intl.DateTimeFormat('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(date);
}

function formatAmount(amount, currency, amountLabel) {
    if (amountLabel) {
        return amountLabel;
    }

    if (amount == null) {
        return '—';
    }

    return new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: currency || 'RUB',
        maximumFractionDigits: 0,
    }).format(amount);
}

function mapPaymentStatus(status, paymentStatus) {
    if (status) {
        return status;
    }

    const statusMap = {
        success: 'Успешно',
        succeeded: 'Успешно',
        error: 'Ошибка',
        canceled: 'Ошибка',
        cancelled: 'Ошибка',
        failed: 'Ошибка',
        in_process: 'В обработке',
        pending: 'В обработке',
    };

    return statusMap[paymentStatus] || paymentStatus || '—';
}

export function mapPayment(payment) {
    return {
        id: payment.id,
        date: payment.paid_at_label || formatPaidAtLabel(payment.paid_at),
        status: mapPaymentStatus(payment.status, payment.payment_status),
        amount: formatAmount(payment.amount, payment.currency, payment.amount_label),
        description: payment.description || 'Оплата подписки',
        paymentMethod: payment.payment_method || '—',
        orderId: payment.order_id || '—',
    };
}

export function mapPaymentsHistory(data) {
    const payments = Array.isArray(data) ? data : data?.payments || [];
    return payments.map(mapPayment);
}
